import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { MultiSelect } from "react-multi-select-component";

import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class CreateTestSeries extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,

    redirect: false,
    allSubjects: [],
    selectedSubjects: [],
    selectedTopics: [],
    alltopics: [],
    allLevels: [],
    test_series_name: "",
    seats: 0,
    small_poster: null,
    large_poster: null,
    payment_type: "free",
    price: "",
    offer_price: "",
    test_start_time: "",
    test_end_time: "",
    negative_marking: "no",
    negative_marking_value: "",
    duration_minutes: 10,
    status: "active",
    show_full_image_in_app: "false",
    search: "",
  };

  componentDidMount() {
    this.getAllSubjects();
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllSubjects + "?search=" + this.state.search + "&limit=150")
        .then((resp) => {
          //   console.log(resp.data.data.docs);
          let array = [];
          resp?.data?.data?.docs.map((item) => {
            array.push({
              label: item?.subject_name,
              value: item?._id,
            });
          });

          this.setState({
            allSubjects: array,
          });
        });
    }
  };

  handleTopic = async () => {
    if (init() === "success") {
      let array = [];
      this.state.selectedSubjects.map((item) => array.push(item.value));

      await axios.get(Constants.getUrls.getAllTopics + "?subject_id=" + array).then((resp) => {
        //   console.log(resp.data.data.docs);
        let array = [];
        resp?.data?.data?.docs.map((item) => {
          array.push({
            label: item?.topic_name,
            value: item?._id,
          });
        });
        this.setState({
          alltopics: array,
        });
      });
    }
  };

  handleLevel = async () => {
    if (init() === "success") {
      await axios
        .get(
          Constants.getUrls.getAllLevels +
            "?subject_id=" +
            this.state.subject_id +
            "&topic_id=" +
            this.state.topic_id
        )
        .then((resp) => {
          //   console.log(resp.data.data.docs);
          this.setState({
            allLevels: resp.data.data.docs,
          });
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFile = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.state.selectedSubjects.length || !this.state.selectedTopics.length) {
      this.setState({
        notification: true,
        message: "Please select at least one subject and one topic.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 5000);
      return;
    }

    if (this.state.payment_type === "paid" && !Number(this.state.price || 0)) {
      this.setState({
        notification: true,
        message: "Paid test series require a valid price.",
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 5000);
      return;
    }

    this.setState({ loading: true });
    let fd = new FormData();

    fd.append("test_series_name", this.state.test_series_name);
    fd.append("small_poster", this.state.small_poster);
    fd.append("large_poster", this.state.large_poster);
    fd.append("seats", this.state.seats);
    fd.append("payment_type", this.state.payment_type);
    fd.append("price", this.state.price);
    fd.append("offer_price", this.state.offer_price);
    fd.append("subject_id", JSON.stringify(this.state.selectedSubjects.map((item) => item.value)));
    fd.append("topic_id", JSON.stringify(this.state.selectedTopics.map((item) => item.value)));
    fd.append("test_series_type", "scheduled");
    fd.append("test_start_time", this.state.test_start_time);
    fd.append("test_end_time", this.state.test_end_time);
    fd.append("negative_marking", this.state.negative_marking);
    fd.append("negative_marking_value", this.state.negative_marking_value || 0);
    fd.append("duration_minutes", this.state.duration_minutes || 10);
    fd.append("status", this.state.status || "active");
    fd.append("show_full_image_in_app", this.state.show_full_image_in_app);

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createTestSerikes, fd)
        .then((resp) => {
          // console.log(resp);
          this.setState({
            notification: true,
            message: resp.data.message,
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err?.response?.data?.message || "Unable to create test series.",
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/testseries" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Create Test Series
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        {/* Select Subject */}
                        <Grid item sm={6}>
                          <InputLabel>Select Subject</InputLabel>
                          <MultiSelect
                            options={this.state.allSubjects}
                            value={this.state.selectedSubjects}
                            onChange={(e) => {
                              // this.state.selectedSubjects
                              console.log(e);
                              this.setState(
                                {
                                  selectedSubjects: e,
                                },
                                () => {
                                  this.handleTopic();
                                }
                              );
                            }}
                            labelledBy="Select Subjects"
                          />
                        </Grid>
                        {/* Select Topic */}
                        <Grid item sm={6}>
                          <InputLabel>Select Topic</InputLabel>
                          <MultiSelect
                            options={this.state.alltopics}
                            value={this.state.selectedTopics}
                            onChange={(e) => {
                              // this.state.selectedSubjects
                              console.log(e);
                              this.setState({
                                selectedTopics: e,
                              });
                            }}
                            labelledBy="Select Subjects"
                          />
                        </Grid>

                        {/* Select Level */}
                        <Grid item sm={6}>
                          <InputLabel>Test Series Name</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="test_series_name"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Test Type</InputLabel>
                          <TextField
                            value="Scheduled Test Series"
                            style={{ width: "100%", height: "100%" }}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>App Card Layout</InputLabel>
                          <Select
                            name="show_full_image_in_app"
                            value={this.state.show_full_image_in_app}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="false">Standard Card</MenuItem>
                            <MenuItem value="true">Full Image Card</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Payment Type</InputLabel>
                          <Select
                            value={this.state.payment_type}
                            onChange={(e) => this.setState({ payment_type: e.target.value })}
                            name="payment_type"
                            label="Select Payment Type"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="free">Free</MenuItem>
                            <MenuItem value="paid">Paid</MenuItem>
                          </Select>
                        </Grid>

                        <Grid item sm={3}>
                          <InputLabel>Seats</InputLabel>
                          <TextField
                            type="number"
                            // label="Subject Name"
                            name="seats"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Negative Marking</InputLabel>
                          <Select
                            value={this.state.negative_marking}
                            onChange={(e) => this.setState({ negative_marking: e.target.value })}
                            name="negative_marking"
                            label=""
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="yes">Yes</MenuItem>
                            <MenuItem value="no">No</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Price</InputLabel>
                          <TextField
                            type="number"
                            // label="Subject Name"
                            name="price"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required={this.state.payment_type === "paid"}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Offer Price</InputLabel>
                          <TextField
                            type="number"
                            // label="Subject Name"
                            name="offer_price"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required={this.state.payment_type === "paid"}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Duration (Minutes)</InputLabel>
                          <TextField
                            type="number"
                            name="duration_minutes"
                            value={this.state.duration_minutes}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={this.state.status}
                            onChange={(e) => this.setState({ status: e.target.value })}
                            name="status"
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                          </Select>
                        </Grid>
                        {this.state.negative_marking === "yes" && (
                          <Grid item sm={3}>
                            <InputLabel>Deduct Marks</InputLabel>
                            <TextField
                              type="number"
                              name="negative_marking_value"
                              onChange={this.handleInput}
                              style={{ width: "100%", height: "100%" }}
                              required
                            />
                          </Grid>
                        )}
                        <Grid item sm={3}>
                          <InputLabel>Test Start Time</InputLabel>
                          <TextField
                            type="datetime-local"
                            name="test_start_time"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item sm={3}>
                          <InputLabel>Test End Time</InputLabel>
                          <TextField
                            type="datetime-local"
                            name="test_end_time"
                            value={this.state.test_end_time}
                            inputProps={{
                              min: this.state.test_start_time,
                            }}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                            required
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item sm={6}>
                          <InputLabel>Select Small Poster</InputLabel>
                          <input type="file" name="small_poster" onChange={this.handleFile} />
                          {this.state.small_poster != null && (
                            <img src={URL.createObjectURL(this.state.small_poster)} />
                          )}
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Select Large Poster</InputLabel>
                          <input type="file" name="large_poster" onChange={this.handleFile} />
                          {this.state.large_poster != null && (
                            <img src={URL.createObjectURL(this.state.large_poster)} />
                          )}
                        </Grid>

                        {/* <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Subject Poster"
                            name="subject_poster"
                            focused
                            onChange={(e) => {
                              this.setState({
                                subject_poster: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}

                        {/* <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Testimonial"
                            name="testimonial"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Creating..." : "Create"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="AgriQuiz Topics"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
